import Products from "../components/Product"

const developments = [
	{
		'name':'Web Cristina G.',
		'tech':'Vue.js',
		'description':'Página web de autora que hice para mi mujer. Es mi primer proyecto web donde apliqué todo lo aprendido de forma autodidacta sobre HTML, CSS, Javascript y Vue.js.',
		'media': require('../resources/cristinagescritoraWeb.gif'),
		'link':'https://www.cristinagescritora.es/'
	},
	{
		'name':'Mi biblioteca manga',
		'tech':'Android/java',
		'description':'Mi primer proyecto de todos. Lo empecé cuando estaba en la universidad, para poner a prueba lo que aprendia en la asignatura optativa de Java y Android, pero no fué hasta hace poco que decidí retomarla y acabar el trabajo.',
		'media': require('../resources/Biblioteca-manga.gif'),
		'link':'https://play.google.com/store/apps/details?id=com.scrogy.mibibliotecamanga'
	},
	{
		'name':'Portfolio',
		'tech':'React.js',
		'description':'Esta web no es solo un portfolio. Es mi primera toma de contacto con React y mi segundo proyecto web.',
		'media': require('../resources/portfolio.gif'),
		'link':'https://www.davidhostalrich.dev'
	},
	{
		'name':'Pdf splitter',
		'tech':'Python',
		'description':'Proyecto rápido que surgió por la necesidad de dividir unas entradas en PDF. Queria una herramienta sencilla, rápida y gratuita, así que cree la mia propia. No había necesidad, pero sí ilusión.',
		'media': require('../resources/pdfsplitter.gif'),
		'link':'https://github.com/Scrogy/PDFSplitter'
	},
	{
		'name':'Voice Assistant ChatGPT',
		'tech':'Web/python/fastAPI',
		'description':'Se usa a chatGPT como asistente virtual para asistirnos en una compra online. Envia tus peticiones usando grabaciones de voz desde el cliente web. El servidor transcribirá tu petición con la IA Whisper, y chatGPT actuará en consecuencia. El dictador de texto de google da voz a la respuesta para que recibamos una respuesta en formato de audio.',
		'media': require('../resources/chatgpt.png'),
		'link':'https://github.com/Scrogy/PDFSplitter' 
	},
	{
		'name': 'Blockchain project',
		'tech':'Solidity',
		'description':'Proyecto actualmente en desarrollo que pretende usar la tencnología blockchain.',
		'media': require('../resources/wip.gif'),
		'link':''
	},
	{
		'name':'Secret project',
		'tech':'React Native',
		'description':'Proyecto actualmente en desarrollo que usa React Native para contruir la aplicación multiplataforma.',
		'media': require('../resources/wip.gif'),
		'link':''
	}
]
  

function Development() {
	
	return (
		<section id="developmentContainer">
			<h2>PROYECTOS</h2>
			<div id="productsPlacement">	
				{
					developments.map((product, index)=>{
						return(
							<Products
								key={index}
								name={product.name}
								tech={product.tech}
								description={product.description}
								media={product.media}
								link={product.link}
							/>
						)
					})
				}
			</div>
		</section>
	);
	
}
export default Development;